import React, { Component, useState } from "react";
import { UncontrolledTooltip, Badge } from "reactstrap";
import { generateOtherValues } from "../oro-module/commonFunctions";

const CleanedLabel = ({ current, star, prependValue, label, labelShortcuts, target }) => {
  let [showtooltip, setShowtooltip] = useState(false);
  let [x, setx] = useState(0);
  let [y, sety] = useState(0);
  let [wd, setwidth] = useState(0);



  const handleLabelClick = (e) => {
    let rect = e.target.getBoundingClientRect();
    let leftPad = e.target.offsetLeft;
    setx(rect.x - leftPad + 15);
    sety(rect.y + rect.height);
    setwidth(rect.width);
    setShowtooltip(!showtooltip);
  }

  const handleSetValue = (value) => {
    let elem = document.getElementById(target);
    if (elem) {
      elem.classList.add("animated");
      elem.classList.add("pulse");
    }
    current.props.liftState({ name: target }, value);
    setShowtooltip(false);
    if (elem) {
      setTimeout(() => { elem.classList.remove("animated"); elem.classList.remove("pulse"); }, 1500);
    }
  }

  return (
    <div className="row">
      <div className={`col-sm-11 nopadding-right `}>
        <span className={labelShortcuts ? 'underline hand' : ''} onClick={(e) => labelShortcuts ? handleLabelClick(e) : null}>{label}{prependValue ? prependValue : ''}</span>
      </div>
      <div className="col-sm-1 nopadding">{star ? <span className="" style={{ color: "#990000" }}>*</span> : ''}</div>

      {showtooltip && <div className="oro-tooltip row" style={{ top: y, left: x, width: wd }}>
        {labelShortcuts.map((lab, idx) => <div key={idx} className="hand col-sm-6 underline tooltip-action" onClick={() => handleSetValue(lab.value)}>{lab.label}</div>)}
      </div>}

    </div>
  )
}

class LabelCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000)) + 1
    };
  }

  generateID = () => {
    return this.state.ttid;
  };
  generateID2() {
    return this.state.ttid2;
  }

  render() {
    const {
      name,
      label,
      target,
      labelShortcuts,
      placeHolder,
      star,
      description, style, prepend
    } = this.props.component;
    let { pageData, openmodals, modalname } = this.props.parentState
    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();
    let { LocalVars } = this.props.parentState;
    let { compressed } = LocalVars;
    let sty = { ...style };
    if (compressed) {
      sty['paddingTop'] = 5;
    }


    let prependObject = {}
    let prependValue = ""
    if (prepend) {
      let sendData = prepend
      prependObject = generateOtherValues(sendData, pageData)

    }
    if (prependObject && Object.keys(prependObject).length != 0) {
      for (var k in prependObject) {
        if (prependObject[k] != undefined && prependObject[k] != "") {
          prependValue += `${prependObject[k]}  `
        }
      }
    }

    if (this.props.conditionalRender == 'readonly') {
      return (
        <div
          id={tooltipID}
          style={sty}
          className={`gray_color ${!compressed ? "form-group-compressed" : "form-group"}   ${this.props.component.widths.parent}`}
        >
          {label}
        </div>
      );
    } else {
      if (description) {
        sty.textDecoration = "underline";
        sty.textDecorationColor = "lightgray";
      }
      return (
        <div
          id={tooltipID}
          style={sty}
          className={`${!compressed ? "form-group-compressed" : "form-group-compressed"}   ${this.props.component.widths.parent}`}
        >
          <CleanedLabel current={this} star={star} label={label} prependValue={prependValue} labelShortcuts={labelShortcuts} target={target} />

          {(description && description instanceof Array) ?
            (
              <UncontrolledTooltip placement="right" target={tooltipID}>
                <ol>{description.map((r, i) => <li key={i}>{r}</li>)}</ol>
              </UncontrolledTooltip>
            ) : description ? (
              <UncontrolledTooltip placement="right" target={tooltipID}>
                {description}
              </UncontrolledTooltip>
            ) : ""
          }
        </div>
      );
    }

  }
}

export default LabelCustom;
